import moment from "moment";
import React from "react";
import { PrimaryButton } from "./shared/button/PrimaryButton";
import StandardModal from "./shared/StandardModal";

function GoogleSyncModal({ open, close, closeable, isSyncRunning, syncStartUnix, syncStats, renderSyncStats, runSync }) {
	const renderActions = () => {
		return isSyncRunning ? (
			<React.Fragment>
				<PrimaryButton
					className="mui-flat-button"
					label={
						<span>
							<i className="fa fa-refresh fa-spin fa-fw inline-spinner-margin-right" />
							Syncing
						</span>
					}
					disabled
				/>
				{syncStartUnix && moment.unix(syncStartUnix).isBefore(moment().subtract(15, "minutes")) && (
					<PrimaryButton className="mui-flat-button" label="Restart Sync" onClick={() => runSync(true)} />
				)}
			</React.Fragment>
		) : (
			<React.Fragment>
				<PrimaryButton className="mui-flat-button" label="Sync" onClick={runSync} />
			</React.Fragment>
		);
	};

	return (
		<StandardModal
			size="medium"
			title={isSyncRunning ? "Google Sync In Progress" : "Sync with Google Classroom?"}
			open={open}
			close={close}
			keepOpen={!closeable && isSyncRunning}
			actions={renderActions()}
		>
			<div>
				<div>
					{"Syncing can help fix out of date classes. "}
					<span className="text-underline">You will be unable to use Classwize</span>
					{" for a few moments while the sync is in progress."}
				</div>
				{!isSyncRunning && (
					<React.Fragment>
						<br />
						<div className="text-red text-bold">
							Any students you have manually added into Google classrooms through Classwize will be lost.
						</div>
						<br />
						<div>If these students regularly attend your class we recommend adding them through Google Classroom instead.</div>
						{renderSyncStats(syncStats, "Latest sync details")}
					</React.Fragment>
				)}
			</div>
		</StandardModal>
	);
}

export default GoogleSyncModal;
